import React from "react";
import styles from "./styles.module.scss";

type Props = {
  Icon: React.FunctionComponent;
  text: string;
  Modal: React.FunctionComponent<{
    closeModal: any;
    isOpened: boolean;
  }>;
  disabled?: boolean;
};

export const PaymentOption = ({
  Icon,
  text,
  Modal,
  disabled = false,
}: Props) => {
  const [opened, setOpened] = React.useState<boolean>(false);

  const handleToggleModal = () => {
    if (!disabled) {
      setOpened(!opened);
    }
  };

  return (
    <>
      <button
        className={`${styles["wrapper"]} ${disabled ? styles["disabled"] : ""}`}
        onClick={handleToggleModal}
        disabled={disabled}
      >
        <Icon />
        <span className={styles["text"]}>{text}</span>
      </button>
      {!disabled && <Modal closeModal={handleToggleModal} isOpened={opened} />}
    </>
  );
};
